import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ConfigurationService } from '@shared/services/configuration.service';

import { environment } from 'environments/environment';

@Component({
  selector: 'home-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
  standalone: false
})
export class JobsComponent implements OnInit {

  readonly keyK12InstructorPosition = 'JOBS-POSITION-K-12-INSTRUCTOR-NAME';
  readonly urlRoot = environment.urlRoot;

  instructorPosition: string = 'K-12 Coding Instructor';

  constructor(
    private configurationService: ConfigurationService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    // If there is a fragment, scroll to it
    if (this.route.snapshot.fragment) {
      this.scrollToAnchor(this.route.snapshot.fragment);
    }

    // Get K-12 instructor position name
    this.configurationService.getItem(this.keyK12InstructorPosition)
      .subscribe((value) => this.instructorPosition = value.Value);
  }

  scrollToAnchor(location: string, wait = 0): void {

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const element = this.document.querySelector('#' + location);
    if (element) {
      setTimeout(() => {

        // Scroll to the fragment
        element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
      }, wait);
    }
  }
}
